import React, { useMemo } from 'react';
import { GetTradingBlockSiteName } from '../../utilities/site';
import { Text } from '../localize/Text';
export const ContactPhone = ({ accountNumber, siteGroup }) => {
    const contactPhoneTextId = useMemo(() => `contact.phone.${GetTradingBlockSiteName(accountNumber, siteGroup)}`, [
        accountNumber,
        siteGroup,
    ]);
    return React.createElement(Text, { id: contactPhoneTextId });
};
//# sourceMappingURL=ContactPhone.js.map